import React from "react";
import { get, noop } from "lodash";
import { DerbyEventStatus } from "@fdr/types/ts/Derby";
import { HomepageCTA } from "@fdr/home/src/utils/types";
import { UnaryFn } from "@tvg/ts-types/Functional";
import {
  Container,
  DerbyLinks,
  HomeHeaderFooterLink
} from "./styled-components";
import { FooterButton, FooterLinkTypes } from "./types";

interface Props {
  // RaceStatus
  raceStatus: DerbyEventStatus;
  // Show derby picks
  showDerbyPicks?: boolean;
  // Derby Url
  derbyRaceUrl?: string;
  headerCTA?: HomepageCTA | null;
  onFooterButtonClick: UnaryFn<FooterButton, void>;
}

const getLink = (link: string, derbyRaceUrl?: string) => {
  if (link.includes("#derbyRace")) {
    return derbyRaceUrl || "";
  }

  return link;
};

const HomeHeaderFooter = ({
  raceStatus = DerbyEventStatus.POST,
  showDerbyPicks = false,
  derbyRaceUrl,
  headerCTA,
  onFooterButtonClick = noop
}: Props) => {
  const text = get(headerCTA, "label", "");
  const type = get(headerCTA, "type", FooterLinkTypes.BET);
  const link = getLink(get(headerCTA, "link.url", ""), derbyRaceUrl);

  return text && link ? (
    <Container
      data-qa-label="derby-footer"
      raceStatus={raceStatus}
      showDerbyPicks={showDerbyPicks}
    >
      <DerbyLinks>
        <HomeHeaderFooterLink
          onClick={() => {
            onFooterButtonClick({
              text,
              url: link
            });
          }}
          to={link}
          type={type}
        >
          {text}
        </HomeHeaderFooterLink>
      </DerbyLinks>
    </Container>
  ) : null;
};

export default HomeHeaderFooter;
